// extracted by css-extract-rspack-plugin
export default {"Flash":"PublishBanners-module__Flash__i3lpom3"};